import React from 'react'
import st from './LeadButtonFilter.module.scss'

const LeadButtonFilter = ({ totalLead, leads, statusLeads }) => {
  const leadCounts = statusLeads.reduce((acc, status) => {
    acc[status.id] = leads.filter(
      (lead) => lead.status_lead_id === status.id,
    ).length
    return acc
  }, {})
  return (
    <div className={st.leadHeaderInfo}>
      <div className={st.leadHeaderInfo__items}>
        {statusLeads.map((status) => (
          <div className={st.leadHeaderInfo__item} key={status.id}>
            <span className={st.leadTitle}>{status.name}</span>
            <div className={st.leadData}>{leadCounts[status.id]}</div>
          </div>
        ))}
      </div>
      <div className={st.leadHeaderInfo__cost}>
        <div className={st.leadTotal}>
          <span>{totalLead}</span> Leads
        </div>
      </div>
    </div>
  )
}

export default LeadButtonFilter
